/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/ban-ts-comment */

export const Utils = {
  data_get: function (arr, key, defaultValue) {
    defaultValue = defaultValue != null ? defaultValue : null;
    if (!arr || typeof arr === 'undefined') {
      return defaultValue;
    }
    if (typeof arr[key] != 'undefined' && arr[key] !== null) {
      return arr[key];
    }
    const keys = key.split('.');
    if (keys.length <= 1) {
      return defaultValue;
    }
    for (let i = 0; i < keys.length; i++) {
      const subArr = arr[keys[i]];
      const keysTemp = keys;
      keysTemp.shift();
      return this.data_get(subArr, keysTemp.join('.'), defaultValue);
    }
    return defaultValue;
  },
  dateFormat: function (date, fstr, isUtc = true) {
    const d = {
      Y: () => isUtc ? date.getUTCFullYear() : date.getFullYear(),
      m: () => isUtc ? date.getUTCMonth() : date.getMonth(),
      d: () => isUtc ? date.getUTCDate() : date.getDate(),
      H: () => isUtc ? date.getUTCHours() : date.getHours(),
      M: () => isUtc ? date.getUTCMinutes() : date.getMinutes(),
      S: () => isUtc ? date.getUTCSeconds() : date.getSeconds()
    };
    return fstr.replace(/%[YmdHMS]/g, function (m) {
      switch (m) {
        case '%Y':
          return String(d.Y());
        case '%m':
          return ('0' + (1 + d.m())).slice(-2);
        case '%d':
          return ('0' + d.d()).slice(-2);
        case '%H':
          return ('0' + d.H()).slice(-2);
        case '%M':
          return ('0' + d.M()).slice(-2);
        case '%S':
          return ('0' + d.S()).slice(-2);
        default:
          return m.slice(1);
      }
    });
  },
  isEmpty: function (obj) {
    if (Array.isArray(obj)) {
      return obj.length === 0;
    } else if (typeof obj === 'object') {
      if (obj == null) {
        return true;
      }
      return Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype;
    } else if (typeof obj === 'string') {
      return obj === 'null' || obj.length == 0;
    } else if (typeof obj === 'undefined') {
      return true;
    }
    return false;
  },
  inArray: function (item, arr) {
    return arr.includes(item);
  },
  randomString: function (len = 10, option) {
    var _option, _option2;
    option = option || {};
    const allCapsAlpha = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
    const allLowerAlpha = 'abcdefghijklmnopqrstuvwxyz'.split('');
    const allUniqueChars = '~!@#$%^&*()_+-=[]{}|;:\'",./<>?'.split('');
    const allNumbers = '0123456789'.split('');
    let base;
    if ((_option = option) != null && _option.only_number) {
      base = [...allNumbers];
    } else if ((_option2 = option) != null && _option2.only_char) {
      var _option3;
      base = [...allCapsAlpha, ...allLowerAlpha];
      if ((_option3 = option) != null && _option3.include_unique) {
        base.push(...allUniqueChars);
      }
    } else {
      base = [...allCapsAlpha, ...allLowerAlpha, ...allNumbers];
    }
    const generator = (chars, length) => {
      return [...Array(length)].map(() => chars[Math.floor(Math.random() * chars.length)]).join('');
    };
    return generator(base, len);
  },
  uuid: function () {
    // Public Domain/MIT
    let d = new Date().getTime(); //Timestamp
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0; //Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      let r = Math.random() * 16; //random number between 0 and 16
      if (d > 0) {
        //Use timestamp until depleted
        r = (d + r) % 16 | 0;
        d = Math.floor(d / 16);
      } else {
        //Use microseconds since page-load if supported
        r = (d2 + r) % 16 | 0;
        d2 = Math.floor(d2 / 16);
      }
      return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
  },
  capitalize: function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  },
  round: function (num) {
    return Math.round((num + Number.EPSILON) * 100) / 100;
  },
  roundNumber(num, dec = 2) {
    return Math.round(num * Math.pow(10, dec)) / Math.pow(10, dec);
  },
  isNumeric: function (str) {
    if (typeof str != 'string') return false; // we only process strings!
    // @ts-ignore
    return !isNaN(str) && !isNaN(parseFloat(str)); // ...and ensure strings of whitespace fail
  },
  ipInRange: function (ip, arr) {
    let isInArray = false;
    const ipSplit = ip.split('.');
    for (let i = 0; i < arr.length; i++) {
      const octet = '(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]?|0)';
      const regex = new RegExp(`^${octet}\\.${octet}\\.${octet}\\.\\*$`);
      const ipBlacklist = arr[i];
      const ipBlacklistSplit = ipBlacklist.split('.');
      if (regex.test(ipBlacklist)) {
        if (ipSplit[0] == ipBlacklistSplit[0] && ipSplit[1] == ipBlacklistSplit[1] && ipSplit[2] == ipBlacklistSplit[2]) {
          isInArray = true;
          break;
        }
      }
      const regex2 = new RegExp(`^${octet}\\.${octet}\\.\\*\\.\\*$`);
      if (regex2.test(ipBlacklist)) {
        if (ipSplit[0] == ipBlacklistSplit[0] && ipSplit[1] == ipBlacklistSplit[1]) {
          isInArray = true;
          break;
        }
      }
      const regex3 = new RegExp(`^${octet}\\.\\*\\.\\*\\.\\*$`);
      if (regex3.test(ipBlacklist)) {
        if (ipSplit[0] == ipBlacklistSplit[0]) {
          isInArray = true;
          break;
        }
      }
      if (ip == arr[i]) {
        isInArray = true;
        break;
      }
    }
    return isInArray;
  },
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  },
  validatePhone(phone) {
    // Loại bỏ tất cả ký tự không phải số
    const cleanedPhone = phone.replace(/\D/g, '');

    // Kiểm tra định dạng số điện thoại Việt Nam
    // Bắt đầu bằng 03, 05, 07, 08, 09 và có 10 chữ số
    const vietnamPhoneRegex = /^(03|05|07|08|09)\d{8}$/;
    return vietnamPhoneRegex.test(cleanedPhone);
  },
  validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  },
  ms: function (input) {
    if (typeof input === 'number') {
      // Nếu đầu vào là số, trả về chuỗi đại diện cho thời gian
      return input + 'ms';
    } else if (typeof input === 'string') {
      // Nếu đầu vào là chuỗi, chuyển đổi nó thành mili giây
      const timeRegex = /^(-?\d*\.?\d+)\s*([a-z]+)?$/i;
      const match = input.match(timeRegex);
      if (!match) {
        throw new Error('Invalid time format');
      }
      const value = parseFloat(match[1]);
      const unit = (match[2] || 'ms').toLowerCase();
      switch (unit) {
        case 'ms':
          return value;
        case 's':
          return value * 1000;
        case 'm':
          return value * 60 * 1000;
        case 'h':
          return value * 60 * 60 * 1000;
        case 'd':
          return value * 24 * 60 * 60 * 1000;
        case 'y':
          return value * 365 * 24 * 60 * 60 * 1000;
        default:
          throw new Error('Invalid time unit');
      }
    } else {
      throw new Error('Invalid input type');
    }
  },
  //chuyển text tiếng việt thành không dấu
  removeVietnameseAccents: function (str) {
    if (!str) return '';
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '') // Remove diacritics
    .replace(/[đĐ]/g, d => d === 'đ' ? 'd' : 'D') // Handle special case for 'đ'
    .replace(/[àáạảãâầấậẩẫăằắặẳẵ]/g, 'a').replace(/[èéẹẻẽêềếệểễ]/g, 'e').replace(/[ìíịỉĩ]/g, 'i').replace(/[òóọỏõôồốộổỗơờớợởỡ]/g, 'o').replace(/[ùúụủũưừứựửữ]/g, 'u').replace(/[ỳýỵỷỹ]/g, 'y').replace(/[ÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴ]/g, 'A').replace(/[ÈÉẸẺẼÊỀẾỆỂỄ]/g, 'E').replace(/[ÌÍỊỈĨ]/g, 'I').replace(/[ÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠ]/g, 'O').replace(/[ÙÚỤỦŨƯỪỨỰỬỮ]/g, 'U').replace(/[ỲÝỴỶỸ]/g, 'Y');
  },
  maskPhone: function (phone) {
    if (!phone) return '';
    // Giữ 2 số đầu và 3 số cuối, thay thế các số ở giữa bằng dấu *
    return phone.replace(/(\d{2})\d+(\d{3})$/, '$1***$2');
  },
  normalizePhone: function (phone) {
    if (!phone) return '';

    // Loại bỏ tất cả ký tự không phải số
    let normalized = phone.replace(/\D/g, '');

    // Nếu số điện thoại bắt đầu bằng 84, chuyển thành 0
    if (normalized.startsWith('84')) {
      normalized = '0' + normalized.slice(2);
    }

    // Nếu số điện thoại không bắt đầu bằng 0, thêm 0 vào đầu
    if (!normalized.startsWith('0')) {
      normalized = '0' + normalized;
    }

    // Kiểm tra độ dài số điện thoại (10 số cho định dạng 0987654321)
    if (normalized.length !== 10) {
      return '';
    }
    return normalized;
  },
  convertToVietnamPhone84: function (phone) {
    // Xóa tất cả ký tự không phải số
    const cleaned = phone.replace(/\D/g, '');
    let converted = '';

    // Nếu bắt đầu bằng 0 và có 10 số (ví dụ: 0912345678)
    if (/^0\d{9}$/.test(cleaned)) {
      converted = '84' + cleaned.slice(1);
    }
    // Nếu bắt đầu bằng 84 và có 11 số (ví dụ: 84912345678)
    else if (/^84\d{9}$/.test(cleaned)) {
      converted = cleaned;
    }
    // Nếu chỉ có 9 số (ví dụ: 912345678), thêm 84 vào đầu
    else if (/^\d{9}$/.test(cleaned)) {
      converted = '84' + cleaned;
    } else {
      // Không hợp lệ
      return null;
    }
    return converted;
  },
  replaceParams: function (text, params) {
    let result = text;
    //console.log('text', text)
    //console.log('params', params)
    // Tìm tất cả các tham số trong text (format: {{param_name}})
    const paramRegex = /{{([^}]+)}}/g;

    // Thay thế từng tham số
    result = result.replace(paramRegex, (match, paramName) => {
      const paramValue = params[paramName.trim()];

      // Nếu không tìm thấy giá trị tham số, giữ nguyên template
      if (paramValue === undefined || paramValue === null) {
        console.warn(`Không tìm thấy giá trị cho tham số: ${paramName}`);
        return match;
      }

      // Chuyển đổi giá trị thành string
      return String(paramValue);
    });
    return result;
  },
  formatCurrency: function (amount, locale = 'vi-VN', currency = 'VND') {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency
    }).format(amount);
  },
  isObject: function (obj) {
    return typeof obj === 'object' && obj !== null;
  },
  slug: function (str, separator = '-') {
    if (!str) return '';
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[đĐ]/g, d => d === 'đ' ? 'd' : 'D').replace(/[àáạảãâầấậẩẫăằắặẳẵ]/g, 'a').replace(/[èéẹẻẽêềếệểễ]/g, 'e').replace(/[ìíịỉĩ]/g, 'i').replace(/[òóọỏõôồốộổỗơờớợởỡ]/g, 'o').replace(/[ùúụủũưừứựửữ]/g, 'u').replace(/[ỳýỵỷỹ]/g, 'y').replace(/[ÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴ]/g, 'A').replace(/[ÈÉẸẺẼÊỀẾỆỂỄ]/g, 'E').replace(/[ÌÍỊỈĨ]/g, 'I').replace(/[ÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠ]/g, 'O').replace(/[ÙÚỤỦŨƯỪỨỰỬỮ]/g, 'U').replace(/[ỲÝỴỶỸ]/g, 'Y').toLowerCase().replace(/[^a-z0-9\s-]/g, '').trim().replace(/[\s-]+/g, separator);
  }
};
Object.defineProperty(String.prototype, 'capitalize', {
  value: function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
  },
  enumerable: false,
  configurable: true
});
//# sourceMappingURL=utils.js.map